export const FIRMWARE_TYPE_PMAX = 'TYPE_PMAX'
export const FIRMWARE_TYPE_PLINK = 'TYPE_PLINK'

export const FIRMWARE_UPGRADE_DEFAULT_TIMEOUT = 86400
export const FIRMWARE_UPGRADE_MINIMAL_TIMEOUT = 3600
export const FIRMWARE_UPGRADE_MAXIMUM_TIMEOUT = 604800